export default "__VITE_ASSET__DJg25fLy__"